import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Slider } from 'primereact/slider';
import { Dropdown } from 'primereact/dropdown';
import Services from '../../service/Services';
import { AutoComplete } from 'primereact/autocomplete';
import { Tooltip } from "primereact/tooltip";
import { Calendar } from "primereact/calendar";
import { addLocale } from "primereact/api";
// import { InputNumber } from 'primereact/inputnumber';
import '../../assets/css/Forms.css'
import '../../assets/css/DialogDemo.css'
import ConfirmBtn from "./ConfirmBtn";
import { Toast } from 'primereact/toast';
import { CambiarFormatoFecha, removeAccents } from '../Funciones';
import axios from 'axios';

const BtnCrearEntregable = ({ idProjectProp, projectProp, dateStartValidityProp, dateEndValidityProp, getClientsProp, individualMonthReportProp, runRenderProp,
    setRunRenderProp, reloadObjectiveProp, runRenderBlockProp, setRunRenderBlockProp, deliverablesProp,
    objectivesProp, projectsUserSessionProp, listDeliverableProp, newDeliverablesProp , isMonthlyRepProp}) => {

    const [projectsUserSession, setProjectsUserSession] = useState([]);
    const [, setObjective] = useState([]);
    /*  const [assignedProjects, setAssingnedProjects] = useState([]); */
    const [clientsUserSession, setClientsUserSession] = useState([]);
    const [deliverables, setDeliverables] = useState([]);
    const [newResetData, setNewResetData] = useState(false)
    const getServices = new Services();
    const [displayBasic, setDisplayBasic] = useState(false);
    const toast = useRef(null);
    const [verifyDuplicity,setVerifyDuplicity] = useState([])
    const [loadingDeliverables,setLoadingDeliverables] = useState(true)



    //Obtener datos del autocompletar entregables

    const [autoDeliverables, setAutoDeliverables] = useState(null)
    const [filteredDeliverables, setFilteredDeliverables] = useState(null);

    const onAutoDeliverablesChange = (e) => {
        setAutoDeliverables(e.value)
        setValidateChange(true)
        if (individualMonthReportProp === false) {
            setSelectedClient(null)
            setSelectedProject({
                id: '',
                name: '',
                dateStartValidity: '',
                dateEndValidity: ''
            })
        }
    }

    const searchDeliverable = (event) => {
        setTimeout(() => {
            let _filteredDeliverables;
            if (!event.query.trim().length) {
                _filteredDeliverables = [...deliverables];
            }
            else {
                _filteredDeliverables = deliverables.filter((object) => {
                    return object.descripcion.toLowerCase().startsWith(event.query.toLowerCase());
                });
            }
            const deliverablesTable = {}
            const uniqueDeliverable = _filteredDeliverables?.filter(function (object) {
                return deliverablesTable.hasOwnProperty(object.id) ? false : (deliverablesTable[object.id] = true)
            })
            setFilteredDeliverables(uniqueDeliverable);
        }, 250);
    }

    var assingnedNewObjectiveDeliverable = false

    if (typeof autoDeliverables === 'string' || autoDeliverables === null) {
        assingnedNewObjectiveDeliverable = false
    } else if (typeof autoDeliverables === 'object') {
        assingnedNewObjectiveDeliverable = true
    }
    const [servicesDeliverables, setServicesDeliverables] = useState([])
    useEffect(() => {
        const source = axios.CancelToken.source()
        if (displayBasic === true && individualMonthReportProp ===true) {
            getServices.getDeliverables().then(data => {
                if (data !== undefined) {
                    setServicesDeliverables(data)
                    setLoadingDeliverables(false)
                }
            });
        }

        return () => {
            if (source) {
                getServices.cancelRequest()
            }
        }
    }, [displayBasic, individualMonthReportProp])// eslint-disable-line react-hooks/exhaustive-deps
    
    useEffect(() => {
        const source = axios.CancelToken.source()
        if (displayBasic === true) {

            if (individualMonthReportProp === true) {
                setObjective(objectivesProp)
                var nameClients = []
                projectsUserSessionProp.forEach(element => {
                    var clients = {}
                    clients.id = element.cliente.id
                    clients.name = element.cliente.nombre
                    nameClients.push(clients)
                })
                const clientsTable = {}
                const uniqueClients = nameClients.filter(function (object) {
                    return clientsTable.hasOwnProperty(object.id) ? false : (clientsTable[object.id] = true)
                })

                if (autoDeliverables !== null && typeof autoDeliverables !== 'string') {
                    if (typeof autoDeliverables === 'object') {
                        var arrProject = []
                        var arrAssinged = []
                        autoDeliverables.objetivos.forEach(element => {
                            arrAssinged.push({
                                name: element.proyecto.nombreproyecto,
                                id: parseInt(element.proyecto.id),
                            })
                        })
                        /*  setAssingnedProjects(arrAssinged) */
                        projectsUserSessionProp.forEach(element => {
                            arrProject.push(element)
                        })
                    }
                } else {
                    const projectsTable = {}
                    const uniqueProjects = projectsUserSessionProp.filter(function (object) {
                        return projectsTable.hasOwnProperty(object.id) ? false : (projectsTable[object.id] = true)
                    })
                    setProjectsUserSession(uniqueProjects)
                    setClientsUserSession(uniqueClients)

                    setSelectedClient({
                        id: getClientsProp.id,
                        name: getClientsProp.client
                    })
                    setSelectedProject({
                        id: parseInt(idProjectProp),
                        name: projectProp,
                        dateStartValidity: dateStartValidityProp,
                        dateEndValidity: dateEndValidityProp
                    })
                }
                setClientsUserSession(uniqueClients)
                /* console.log(deliverablesProp) */
                var arrDeliverables = []
                const result = deliverablesProp.map(item => {
                    return item.objetivos.map(j => {
                        var boolean
                        if (j.proyecto.id === parseInt(idProjectProp)) {
                            boolean = item
                        }
                        return boolean
                    })
                })
                result.forEach(i => {
                    i.forEach(j => {
                        if (j !== undefined) {
                            if (j.length !== 0) {
                                arrDeliverables.push(j)
                            }
                        }
                    })
                })
                var newData = []
                for (var i = 0; i < deliverablesProp.length; i++) {
                    var equal = false;
                    for (var j = 0; j < arrDeliverables.length & !equal; j++) {
                        if (deliverablesProp[i]['id'] === arrDeliverables[j]['id'] &&
                            deliverablesProp[i]['descripcion'] === arrDeliverables[j]['descripcion'])
                            equal = true;
                    }
                    if (!equal) newData.push(deliverablesProp[i]);
                }
                var filterDeliverableForClient = []
                servicesDeliverables.forEach(element => {
                    element.objetivos.forEach(i => {
                        if (i.proyecto.cliente.id === getClientsProp.id) {
                            filterDeliverableForClient.push(element)
                        }
                    })
                })
                setDeliverables(filterDeliverableForClient)
            }
        }

        return () => {
            if (source) {
                getServices.cancelRequest()
            }
        }
    }, [idProjectProp, projectProp, autoDeliverables, reloadObjectiveProp, objectivesProp, servicesDeliverables, displayBasic])// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (individualMonthReportProp === false && displayBasic ===true) {

            getServices.getObjectives().then(data => {
                if (data !== undefined) {
                    setObjective(data)
                }
            });
            getServices.getProyectosUsuarios().then(data => {
                if (data !== undefined) {
                    var nameClients = []
                    data.forEach(element => {
                        var clients = {}
                        clients.id = element.cliente.id
                        clients.name = element.cliente.nombre
                        nameClients.push(clients)
                    })
                    const clientsTable = {}
                    const uniqueClients = nameClients.filter(function (object) {
                        return clientsTable.hasOwnProperty(object.id) ? false : (clientsTable[object.id] = true)
                    })

                    if (autoDeliverables !== null && typeof autoDeliverables !== 'string') {
                        if (typeof autoDeliverables === 'object') {
                            var arrProject = []
                            var arrAssinged = []
                            autoDeliverables.objetivos.forEach(element => {
                                arrAssinged.push({
                                    name: element.proyecto.nombreproyecto,
                                    id: parseInt(element.proyecto.id),
                                })
                            })
                            /*  setAssingnedProjects(arrAssinged) */
                            data.forEach(element => {
                                arrProject.push(element)
                            })
                        }
                    } else {
                        /*  setAssingnedProjects([]) */
                        setProjectsUserSession(data)
                        setClientsUserSession(uniqueClients)
                    }
                    setClientsUserSession(uniqueClients)
                }
            });
            getServices.getDeliverables().then(data => {
                if (data !== undefined) {
                    setDeliverables(data)
                    setLoadingDeliverables(false)
                }
            });

        }


    }, [individualMonthReportProp, displayBasic])// eslint-disable-line react-hooks/exhaustive-deps


    const [setPosition] = useState('center');

    const dialogFuncMap = {
        'displayBasic': setDisplayBasic,
    }

    const onClick = (name, position) => {
        dialogFuncMap[`${name}`](true);
        if (position) {
            setPosition(position);
        }
    }

    const onHide = (name) => {
        dialogFuncMap[`${name}`](false);
    }

    const [validateChange, setValidateChange] = useState(false)

    //Obtener datos del select tipo de clientes

    const [selectedClient, setSelectedClient] = useState({
        name: '',
        id: ''
    })

    const clients = clientsUserSession.map(item => {
        const av = { name: item.name, id: parseInt(item.id) }
        return av
    })

    const onClientChange = (e) => {
        setSelectedClient(e.value);
        setSelectedObjectives({
            descriptionObjectives: '',
            id: ''
        })
        setValidateChange(true)
    }

    //Obtener datos del select Proyecto

    const [selectedProject, setSelectedProject] = useState({
        id: '',
        name: '',
        dateStartValidity: '',
        dateEndValidity: ''
    })


    var projectClient = [];
    const loadProjects = () => {
        if (selectedClient !== undefined) {
            const result = projectsUserSession.filter(function (object) {
                var idClient = parseInt(object.cliente.id);
                return idClient === selectedClient.id;
            });
            result.forEach(element => {
                projectClient.push(element);
            });
            projectClient.sort(function (a, b) {
                var textA = a.name;
                var textB = b.name;
                return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
            });
        }
        return projectClient;
    };

    var dateValidError = false;
    var messageDateValidError = '';

    if (selectedClient !== null) {
        loadProjects();
        // Ya no mostramos error si no hay proyectos vigentes actualmente
        dateValidError = false;
        messageDateValidError = '';
    }

    const proyectos = projectClient.map(item => {
        const av = { name: item.nombre, id: parseInt(item.id), dateStartValidity: item.fechainiciovigencia, dateEndValidity: item.fechafinvigencia };
        return av;
    });

    const onProjectsChange = (e) => {
        setSelectedProject(e.value);
        setSelectedObjectives({
            descriptionObjectives: '',
            id: ''
        })
        setValidateChange(true)
    }

    //Obtener datos del select objetivo

    const [selectedObjectives, setSelectedObjectives] = useState({
        descriptionObjectives: '',
        id: ''
    })

    //var porjectsObjectives = []

    const [objectives, setObjectives] = useState([]);
    const objectivesSource = useRef(null);
    const [objectivesCache, setObjectivesCache] = useState({});
    const [isLoadingObjectives, setIsLoadingObjectives] = useState(false);

    useEffect(() => {
        if (selectedProject.id !== '') {
            if (individualMonthReportProp) {
                // Usar objetivos del prop cuando estamos en informe mensual
                const monthlyReportObjectives = objectivesProp
                    .filter(item => item.proyectos.some(p => p.proyecto.id === parseInt(selectedProject.id)))
                    .map(item => ({
                        descriptionObjectives: item.descripcion,
                        id: item.id
                    }));
                setObjectives(monthlyReportObjectives);
                setIsLoadingObjectives(false);
                return;
            }

            if (objectivesSource.current) {
                objectivesSource.current.cancel('Nueva petición iniciada');
            }
        
            objectivesSource.current = axios.CancelToken.source();
        
            const fetchObjectives = async () => {
                setIsLoadingObjectives(true);
                try {
                    // Verificar si ya existe en caché
                    if (objectivesCache[selectedProject.id]) {
                        setObjectives(objectivesCache[selectedProject.id]);
                        return;
                    }

                    const result = await getServices.getObjectivesV3([selectedProject.id]);
                    
                    if (result) {
                        const projectObjectives = result
                            .filter(item => item.proyectos.some(p => p.proyecto.id === parseInt(selectedProject.id)))
                            .map(item => ({
                                descriptionObjectives: item.descripcion,
                                id: item.id
                            }));
                        
                        // Guardar en caché
                        setObjectivesCache(prev => {
                            return {
                                ...prev,
                                [selectedProject.id]: projectObjectives
                            };
                        });
                        setObjectives(projectObjectives);
                    }
                } catch (error) {
                    setObjectives([]); // Establecer array vacío en caso de error
                } finally {
                    setIsLoadingObjectives(false);
                }
            };
        
            fetchObjectives();
        } else {
            setObjectives([]);
        }
        
        return () => {
            if (objectivesSource.current) {
                objectivesSource.current.cancel('Componente desmontado');
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedProject.id, individualMonthReportProp, objectivesProp]);

    const onObjectivesChange = (e) => {
        setSelectedObjectives(e.value);
        setValidateChange(true)
    }

    //Obtener datos del input entregable

    const [inputDeliverable, setInputDeliverable] = useState({
        deliverable: ''
    })

    const onDeliverableChange = (event) => {

        setInputDeliverable({
            ...inputDeliverable,
            [event.target.name]: event.target.value
        })
        setValidateChange(true)
    }

    //Obtener datos del porcentaje ingresado

    const [percentage, setPercentage] = useState(0);

    const onPercentageChange = (e) => {
        setPercentage(e.value)
        setValidateChange(true)
    }

    useEffect(() => {
        if (newResetData === true) {
            resetData()
        }
    }, [newResetData])// eslint-disable-line react-hooks/exhaustive-deps

    // calendar de fecha cumplimiento

    const [date, setDate] = useState(null);

    const onDateChange = (e) => {
        let fecha = e.value
        setDate(fecha)
        setValidateChange(true)
    }

    addLocale('es', {
        firstDayOfWeek: 1,
        dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
        dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
        dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
        monthNames: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
        monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
        today: 'Hoy',
        clear: 'Limpiar'
    });

    //Validar si hubo algun cambio 

    var Changes = false
    if (validateChange === true) {
        Changes = true
    }

    //Almacenamos los valores para enviarlos por props

    const idSelectProjects = selectedProject.id
    const idSelectObjective = selectedObjectives.id
    var idDeliverable
    var deliverable
    var creationDate
    var createdBy

    if (assingnedNewObjectiveDeliverable === false) {
        idDeliverable = null
        deliverable = inputDeliverable.deliverable
    } else if (assingnedNewObjectiveDeliverable === true) {
        idDeliverable = autoDeliverables.id
        deliverable = autoDeliverables.descripcion
        creationDate = CambiarFormatoFecha(autoDeliverables.fechacreacion)
        createdBy = autoDeliverables.creadopor
    }

    // función para restablecer los datos del formulario

    const resetData = () => {
        if (individualMonthReportProp === false) {
            setSelectedClient(null)
            setSelectedProject({
                id: '',
                name: '',
                dateStartValidity: '',
                dateEndValidity: ''
            })
            setVerifyDuplicity([])
        }
        setAutoDeliverables(null)
        setSelectedObjectives({
            descriptionObjectives: '',
            id: ''
        })
        setInputDeliverable({
            deliverable: ''
        })
        /* setAssingnedProjects([]) */
        setDate(null)
        setPercentage(0)
        setValidateChange(false)
        setValidateErrorDuplicity(false)
    }

    // Modal para el botón regresar

    const ModalBack = () => {

        const [displayConfirmation, setDisplayConfirmation] = useState(false);
        const [setPosition] = useState('center');

        const dialogFuncMap = {
            'displayConfirmation': setDisplayConfirmation,

        }

        const onClick = (name, position) => {
            dialogFuncMap[`${name}`](true);
            if (position) {
                setPosition(position);
            }
        }

        const onHide = (name) => {
            dialogFuncMap[`${name}`](false);

        }

        const Back = (name) => {
            setDisplayBasic(false)
            dialogFuncMap[`${name}`](false);
            resetData()
        }
        const renderFooter = (name) => {
            return (
                <div>
                    <Button label="Cancelar" icon="pi pi-times" onClick={() => onHide(name)} className="p-button-text" />
                    <Button label="Aceptar" icon="pi pi-check" onClick={() => Back(name)} autoFocus />
                </div>
            );
        }

        return (
            <>
                <Button label="Regresar" icon="pi pi-times" onClick={() => onClick('displayConfirmation')} className="p-button-text" />

                <Dialog className="dialog-demo" header="Advertencia" visible={displayConfirmation} modal style={{}} footer={renderFooter('displayConfirmation')} onHide={() => onHide('displayConfirmation')}>
                    <div className="confirmation-content">
                        <i className="pi pi-exclamation-triangle p-mr-3" style={{ fontSize: '2rem' }} />
                        <span style={{ textAlign: 'center' }}>No se ha guardado la información registrada, ¿desea continuar?</span>

                    </div>
                </Dialog>

            </>
        )
    }

    const [showModal, setShowModal] = useState(false)

    const AddMoreDeliverables = () => {
        const [displayBasic2, setDisplayBasic2] = useState(false);
        const [isProcessing, setIsProcessing] = useState(false);
    
        useEffect(() => {
            if (showModal) {
                setDisplayBasic2(true);
            }// eslint-disable-next-line 
        }, [showModal]);
    
        const handleDialogAction = useCallback((action) => {
            if (isProcessing) return;
    
            setIsProcessing(true);
    
            try {
                // Resetear estados del modal
                setDisplayBasic2(false);
                setShowModal(false);
    
                // Acciones dependiendo de la elección
                if (action === 'add') {
                    // Si elige agregar otro entregable
                    if (setRunRenderProp) {
                        setRunRenderProp(prev => prev + 1);
                    }
                    
                    if (setRunRenderBlockProp) {
                        setRunRenderBlockProp(prev => prev + 1);
                    }
    
                    resetData(); 
                    setDisplayBasic(true);
                } else if (action === 'hide') {
                    
                    setDisplayBasic(false)
                    // Si elige no agregar otro entregable
                    if (setRunRenderProp) {
                        setRunRenderProp(prev => prev + 1);
                    }
                    
                    if (setRunRenderBlockProp) {
                        setRunRenderBlockProp(prev => prev + 1);
                    }
    
                    if (isMonthlyRepProp === false) {
                        window.location.href = "/registroActividades/entregables";
                    }
                }
            } catch (error) {
                console.error('Error en la acción del diálogo:', error);
            } finally {
                setIsProcessing(false);
            }// eslint-disable-next-line 
        }, [
            isProcessing, 
            setRunRenderProp, 
            setRunRenderBlockProp, 
            resetData, 
            setDisplayBasic, 
            isMonthlyRepProp
        ]);

        const renderFooter = useCallback(() => {
            return (
                <div>
                    <Button 
                        label="No" 
                        icon="pi pi-times" 
                        onClick={() => handleDialogAction('hide')} 
                        disabled={isProcessing}
                        autoFocus 
                        className="p-button-text" 
                    />
                    <Button 
                        label="Si" 
                        icon="pi pi-check" 
                        onClick={() => handleDialogAction('add')} 
                        disabled={isProcessing}
                        autoFocus 
                    />
                </div>
            );
        }, [handleDialogAction, isProcessing]);

        return (
            <div className="dialog-demo">
                <div className="card">
                    <Dialog 
                        className="dialog-demo" 
                        header="Advertencia" 
                        visible={displayBasic2} 
                        modal 
                        footer={renderFooter()} 
                        onHide={() => handleDialogAction('hide')}
                    >
                        <div className="confirmation-content">
                            <i className="pi pi-exclamation-triangle p-mr-3" style={{ fontSize: '2rem' }} />
                            <span style={{ textAlign: 'center' }}>
                                Información registrada satisfactoriamente ¿Desea registrar otro entregable?
                            </span>
                        </div>
                    </Dialog>
                </div>
            </div>
        );
    }

    const renderFooter = (name) => {
        return (
            <div>
                {Changes ?
                    <ModalBack />
                    :
                    <Button label="Regresar" icon="pi pi-times" onClick={() => onHide(name)} className="p-button-text" />
                }
                {
                    registerPermission ?
                        <ConfirmBtn
                            tittle="Confirmar Registro"
                            menssage={assingnedNewObjectiveDeliverable ? "¿Estás seguro de guardar esta información?" : "¿Está seguro de Crear este entregable?"}
                            action={assingnedNewObjectiveDeliverable ? "Update" : "Create"}
                            label={assingnedNewObjectiveDeliverable ? "Asignar" : "Guardar"}
                            icon="pi pi-plus-circle"
                            idProjectProp={idSelectProjects}
                            idObjectiveProp={idSelectObjective}
                            idDeliverableProp={idDeliverable}
                            deliverableProp={deliverable}
                            percentageProp={percentage}
                            dateProp={date === null ? date : CambiarFormatoFecha(date)}
                            setShowModal={setShowModal}
                            statusProp={1}
                            creationDateProp={creationDate}
                            createdByProp={createdBy}
                            assingnedNewObjectiveDeliverableProp={assingnedNewObjectiveDeliverable}
                            runRenderProp={runRenderProp}
                            setRunRenderProp={setRunRenderProp}
                            runRenderBlockProp={runRenderBlockProp}
                            setRunRenderBlockProp={setRunRenderBlockProp}
                            deleteDetailProp={false}
                            setDisplayBasicProp={assingnedNewObjectiveDeliverable ? setDisplayBasic : undefined}
                            setNewResetDataProp={setNewResetData}
                        />

                        :
                        ""}

            </div>
        );
    }

    // validaciones

    var deliverableError = false
    var deliverableMessage = ''

    if (deliverable !== '') {
        if (deliverable.length < 10) {
            deliverableError = true
            deliverableMessage = 'La descripción del entregable es demasiado corta'
        } else if (deliverable.length > 110) {
            deliverableError = true
            deliverableMessage = 'La descripción del entregable supera el limite permitido de 110 caracteres'
        }
    }


    /*  const optionDisabledProjects = (e) => {
         var disabled = false
         assignedProjects.forEach(element => {
             if (parseInt(element.id) === e.id) {
                 disabled = true
             }
         })
         return disabled
     } */

    const [validateErrorDuplicity, setValidateErrorDuplicity] = useState(false)

    const validateDuplicity = (deliverables, inputDeliverable, projectId) => {
        let arrEqualsProjects = [];
        deliverables.forEach(object => {
            if (removeAccents(object.descripcion) === removeAccents(inputDeliverable)) {
                object.objetivos.forEach(objective => {
                    if (objective.proyecto.id === projectId) {
                        arrEqualsProjects.push(object);
                    }
                });
            }
        });
        return arrEqualsProjects.length !== 0;
    };
    
    // Efecto para obtener entregables
    useEffect(() => {
        const source = axios.CancelToken.source()

        const projectId = isMonthlyRepProp ? idProjectProp : selectedProject.id;
        if (projectId) {
            const fetchDeliverables = async () => {
                try {
                    const data = await getServices.getDeliverablesByProjects([projectId]);
                    setVerifyDuplicity(data || []);
                } catch (error) {
                    // console.error("Error fetching deliverables:", error);
                }
            };
            fetchDeliverables();
        }

        return () => {
            if (source) {
                getServices.cancelRequest()
            }
        }
    }, [selectedProject, idProjectProp, isMonthlyRepProp]); // eslint-disable-line
    
    // Efecto unificado para validación de duplicidad
    useEffect(() => {
        const validate = async () => {
            try {
                const projectId = isMonthlyRepProp ? idProjectProp : selectedProject.id;
                const inputName = inputDeliverable.deliverable || (autoDeliverables?.descripcion || '');
                
                if (inputName && projectId && verifyDuplicity.length!==0) {
                    const isDuplicated = await validateDuplicity(
                        verifyDuplicity,
                        inputName,
                        projectId
                    );
    
                    setValidateErrorDuplicity(isDuplicated);
                    
                    if (isDuplicated) {
                        toast.current.show({
                            severity: 'error',
                            summary: 'Error',
                            detail: 'Entregable pre-existente',
                            life: 3000
                        });
                    }
                }
            } catch (error) {
                // console.error("Validation error:", error);
            }
        };
    
        validate();
    }, [verifyDuplicity, inputDeliverable, autoDeliverables, selectedProject, idProjectProp]); // eslint-disable-line
    
    var deliverableAutoCompleteError = false
    var deliverableAutoCompleteMessage = ''

    if (typeof autoDeliverables === 'string' || autoDeliverables !== null) {
        if (autoDeliverables.descripcion?.length > 110) {
            deliverableAutoCompleteError = true
            deliverableAutoCompleteMessage = 'El entregable ingresado supera los 110 caracteres'
        } else {
            deliverableAutoCompleteError = false
            deliverableAutoCompleteMessage = ''
        }
    }
    var dateError = false
    var dateMessage = ''

    // validar fechas dentro del rango del proyecto seleccionado

    const validateDate = () => {
        var newDate = CambiarFormatoFecha(date)
        if (newDate >= selectedProject.dateStartValidity && newDate <= selectedProject.dateEndValidity) {
            dateError = false
            dateMessage = ''
        } else {
            dateError = true
            dateMessage = 'La fecha de cumplimiento esta fuera del rango de fechas del proyecto seleccionado'
        }
    }

    if (date !== null && selectedProject.id !== '') {
        validateDate()
    }


    // validación para registrar

    var registerPermission = false

    if (deliverable !== '' && deliverableError === false && selectedObjectives.id !== '' && dateError === false
        && selectedProject !== null && selectedProject.id !== '' && validateErrorDuplicity === false) {
        registerPermission = true
    }

    return (

        <div className="">
            <Toast ref={toast} />
            <div>
                <button className="btnAdd" onClick={() => {
                    onClick('displayBasic')
                    resetData()
                }}><span className="pi pi-plus Add"></span>Gestionar entregables</button>
                <AddMoreDeliverables />
                <Dialog className="modal" header="Gestionar entregables" visible={displayBasic} style={{}} footer={renderFooter('displayBasic')} onHide={() => onHide('displayBasic')}>
                    <div className="p-fluid p-formgrid p-grid">

                        <form style={{ display: 'contents' }} >

                            <div className="p-field p-col-12 p-md-12">
                                <label className="labels" >Buscar Entregable para asignar proyecto
                                    <Tooltip target=".custom-target-icon" autoHide={false} />
                                    <i className="custom-target-icon pi pi-question-circle" style={{ marginLeft: '5px' }}
                                        data-pr-tooltip="Antes de registrar un nuevo entregable debe buscar en la siguiente lista si este entregable ya esta creado, si es asi podrá asignar un nuevo proyecto, si no existe el entregable podrá crear uno nuevo"
                                        data-pr-position="right" mouseTrack mouseTrackLeft={10} data-pr-at="right+1 top" data-pr-my="left center+6"
                                        data-pr-classname="tooltip-objective"
                                    ></i>
                                </label>
                                <AutoComplete disabled={loadingDeliverables} dropdown value={autoDeliverables} suggestions={filteredDeliverables} filterMatchMode="startsWith"
                                    completeMethod={searchDeliverable} onChange={onAutoDeliverablesChange} field="descripcion" placeholder="Buscar entregable"
                                    className={deliverableAutoCompleteError ? "auto p-invalid" : "auto"}
                                />
                                <p className="mensajeError">{deliverableAutoCompleteError ? deliverableAutoCompleteMessage : ""}</p>
                            </div>
                            {assingnedNewObjectiveDeliverable ?
                                <div className="p-field p-col-12 p-md-12">
                                    <label className="labels" >
                                        {individualMonthReportProp ?
                                            `Se asignará el proyecto: ${selectedProject.name} al entregable: ${autoDeliverables.descripcion}`
                                            :
                                            `Seleccione un nuevo proyecto para asignarle al entregable: ${autoDeliverables.descripcion}`
                                        }
                                    </label>
                                </div>
                                :
                                ""
                            }
                            <div className="p-field p-col-12 p-md-6">
                                <label className="labels" >Cliente<span className="require">*</span></label>
                                <Dropdown value={selectedClient} options={clients} onChange={onClientChange} placeholder="Seleccione un cliente"
                                    className="p-column-filter " emptyMessage="No hay resultados" name="client" optionLabel="name"
                                    disabled={individualMonthReportProp} filter
                                />
                            </div>
                            <div className="p-field p-col-12 p-md-6">
                                <label className="labels" >Proyecto<span className="require">*</span></label>
                                <Dropdown value={selectedProject} options={proyectos} onChange={onProjectsChange} name="proyecto" optionLabel="name"
                                    placeholder="Seleccione un proyecto" disabled={individualMonthReportProp} filter
                                    emptyMessage='No hay resultados' className={dateValidError ? "p-invalid" : ""} /* optionDisabled={optionDisabledProjects} */
                                />
                                <p className="mensajeError">{dateValidError ? messageDateValidError : ""}</p>
                            </div>
                            <div className={assingnedNewObjectiveDeliverable ? "p-field p-col-12 p-md-12" : "p-field p-col-12 p-md-6"}>
                                <label className="labels" >Objetivo<span className="require">*</span>
                                    {individualMonthReportProp ?
                                        ""
                                        :
                                        <>
                                            <Tooltip target=".custom-target-icon" autoHide={false} />
                                            <i className="custom-target-icon pi pi-question-circle" style={{ marginLeft: '5px' }}
                                                data-pr-tooltip="Los objetivos deshabilitados de la lista ya están asignados al entregable"
                                                data-pr-position="right" mouseTrack mouseTrackLeft={10} data-pr-at="right+1 top" data-pr-my="left center+6"
                                                data-pr-classname="tooltip-objective"
                                            ></i>
                                        </>
                                    }
                                </label>
                                 <Dropdown 
                                    value={selectedObjectives} 
                                    options={objectives || []} 
                                    onChange={onObjectivesChange} 
                                    name="objetivo" 
                                    optionLabel="descriptionObjectives"
                                    placeholder={isLoadingObjectives ? "Cargando objetivos..." : "Seleccione un objetivo"}
                                    emptyMessage='No hay resultados' 
                                    filter
                                    disabled={isLoadingObjectives}
                                />
                            </div>
                            {assingnedNewObjectiveDeliverable ?
                                ""
                                :
                                <div className="p-field p-col-12 p-md-6">
                                    <label className="labels" >Entregable<span className="require">*</span></label>
                                    <InputText type='text' value={deliverable} onChange={onDeliverableChange} name="deliverable" placeholder="Ingrese un entregable"
                                        className={deliverableError ? "p-invalid" : ""}
                                    />
                                    <p className="mensajeError">{deliverableError ? deliverableMessage : ""}</p>
                                </div>
                            }
                            <div className="p-field p-col-12 p-md-6">
                                <label className="labels" >Fecha Cumplimiento</label>
                                <Calendar placeholder="Seleccione una fecha" value={date} onChange={onDateChange} dateFormat="dd-mm-yy" locale="es"
                                    className={dateError ? "p-invalid" : ""}
                                />
                                <p className="mensajeError">{dateError ? dateMessage : ""}</p>
                            </div>
                            <div className="p-field p-col-12 p-md-6">
                                <label className="labels" >Porcentaje cumplimiento</label>
                                <h5 style={{ marginBottom: '13px' }}> {percentage} %</h5>
                                <Slider value={percentage} onChange={onPercentageChange} step={5} />
                            </div>
                        </form>

                    </div>
                </Dialog>
            </div>
        </div>
    )

}
export default BtnCrearEntregable